import VueI18n from "vue-i18n";

import { LocationType, Opportunity } from "@/services/DTOs";
import { OpportunityServiceCodes } from "@/services/DTOs/OpportunityServices";
import { Dictionary } from "./Dictionary";

export const getId = (slug: string) => {
  return slug.split("-")[0];
};

export const opportunityHasServices = (opp: Opportunity | undefined, serviceCodes: OpportunityServiceCodes[]): boolean => {
  const oppServices = opp?.serviceTypes || [];
  const codes = oppServices.map((s) => s.code);

  return codes.some((code) => {
    return serviceCodes.includes(code);
  });
};

export function reasonToFeedbackText(): Dictionary<string> {
  return {
    "applicant-didnt-show-to-interview": "Applicant didn't show up to the interview",
    "applicant-didnt-submit-test": "Applicant didn't complete the test(s)",
    "applicant-quited": "Applicant decided to quit the process",
    "didnt-pass-test": "Applicant didn't pass the test(s)",
    "expected-compensation-outside-of-budget": "The expected compensation is outside the budget",
    "experience-years-overall": "Years of experience overall",
    "experience-years-skills": "Years of experience per skill",
    "hired-another-candidate": "Other stronger candidates",
    "incomplete-genome": "Incomplete professional genome",
    "incomplete-submitted-information": "Information submitted is incomplete",
    "language-self-aware": "Language fluency",
    "language": "Language(s)",
    "location": "Location isn't a match",
    "no-match": "No match",
    "no-professional-cultural-fit": "Not a cultural match/fit",
    "not-defined": "No ruling out reason provided",
    "not-enough-experience": "Not enough proficiency in the skill(s)",
    "offer-rejected": "Applicant rejected offer",
    "samples-dont-match-requirements": "Work samples don't match the company's requirements",
    "screening-questions": "Pre-screening questions answers",
    "skills-required-self-aware": "Skill proficiency",
    "skills-required": "Skills required",
    "stronger-candidates": "Other stronger candidates",
    "unresponsive-candidate": "Applicant is unresponsive"
  };
}

export function getFormattedLocationForOpportunity(i18n: VueI18n, opportunity: Opportunity): string | undefined {
  const locations = opportunity.place.location || [];
  const concatWords = (words: string[], connector: string): string => {
    const separator = words.length > 2 && i18n.locale === "en" ? "," : "";

    return words.length > 0
      ? words.length > 1
        ? `${words.slice(0, -1).join(", ")}${separator} ${connector} ${words[words.length - 1]}`
        : words[0]
      : "";
  };

  switch (opportunity.place.locationType) {
    case LocationType.RemoteAnywhere:
      return i18n.t("Remote (anywhere)") as string;
    case LocationType.RemoteCountries:
      return `${i18n.t("Remote (for $location residents)", {
        location: concatWords(locations.map((p) => p.id), i18n.t("and") as string)
      })}`;
    case LocationType.RemoteTimezones:
      return i18n.t("Remote (specific timezone)") as string;
    case LocationType.Hybrid:
      return `${i18n.t("Hybrid (for $location residents)", {
        location: concatWords(locations.map((p) => p.id), i18n.t(
          "and"
        ) as string)
      })}`;
    case LocationType.PhysicalLocation:
      return locations.map((p) => p.id).join(", ");
    default:
      return undefined;
  }
}
